import { createSlice } from "@reduxjs/toolkit";

import { deploy } from "./thunks";
import { DeployState } from "./types";

const initialState: DeployState = {
  isLoading: false,
  data: undefined
};

const deploySlice = createSlice({
  name: "deploy",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(deploy.pending, state => {
        state.isLoading = true;
      })

      .addCase(deploy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = undefined;
        state.data = action.payload;
      })
      .addCase(deploy.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export default deploySlice.reducer;
